import { HTTP_CP_SignUp_Request_ClientUser } from '@api-new/authservice';
import { PropertyFormValues } from '@app/sign-up/forms/property.form';
import { CreateUserFormValues } from '@client-ui/components/forms/create-user-form/create-user.form';
import { dateToIsoStringWithoutTimezone } from '@shared-lib/utils/date-utils/date-to-iso-string-without-timezone';
import { signUpPropertyToResidentialAddressAdapter } from '@shared/store/sign-up/adapters/sign-up-property.adapter';

export const signUpClientUserFromToHttpRequestAdapter = (
  clientData: CreateUserFormValues,
  referralCode: string | null,
  property: PropertyFormValues | null,
  companyId: string,
): HTTP_CP_SignUp_Request_ClientUser => {
  return {
    email: clientData.email,
    phoneNumber: clientData.phoneNumber,
    firstName: clientData.firstName,
    middleName: clientData.middleName.length > 0 ? clientData.middleName : undefined,
    lastName: clientData.lastName,
    dateOfBirth: dateToIsoStringWithoutTimezone(clientData.dateOfBirth) ?? undefined,
    referralCode: referralCode ?? undefined,
    residentialAddress: signUpPropertyToResidentialAddressAdapter(property),
    companyId,
  };
};
